import { render, staticRenderFns } from "./PlayerSessionCard.vue?vue&type=template&id=20a7da57&"
import script from "./PlayerSessionCard.vue?vue&type=script&lang=js&"
export * from "./PlayerSessionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports